import React, { useContext, useEffect } from 'react';
import { Modal } from 'flowbite-react';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import MyQuestionsContext from '../context/QuestionsContext';

import Loading from './Loading';
import ErrorWrapper from './ErrorWrapper';

export const cutSpaces = (text) => {
    return text.replace(/\n{3,}/, '\n\n').replace(/ +/g, ' ');
}

const style = {
    formInput: "block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none  focus:outline-none focus:ring-0 focus:border-teal-500 peer",
    formLabel: "peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-2 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-teal-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
}
const ModalQuestionsUpdate = ({ isModalQuestionsUpdateOpen, setIsModalQuestionsUpdateOpen, setSuccessAlert }) => {
    const { question, updateQuestion, error, loading, setError } = useContext(MyQuestionsContext);

    const schema = yup.object().shape({
        questionTitle: yup.string().required("La pregunta es requerida").max(60, "La pregunta no puede tener más de 60 caracteres").min(5, "La pregunta no puede tener menos de 5 caracteres").trim().transform((currentValue) => cutSpaces(currentValue)),
        questionAnswer: yup.string().required("La respuesta es requerida").max(240, "La respuesta no puede tener mas de 240 caracteres").min(5, "La respuesta no puede tener menos de 5 caracteres").trim().transform((currentValue) => cutSpaces(currentValue)),
        })

    const { handleSubmit, register, reset, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        const res = await updateQuestion(data, question.questionId)
        if(res.error){
            setError({"error": true, "message": res.response})
            setTimeout(() => {
                setError({ "error": false, "message": "" })
            }, 3000);
        }else{
            reset()
            setError({"error": false, "message": ""})
            setIsModalQuestionsUpdateOpen(false)
            setSuccessAlert("Pregunta actualizada correctamente")
            setTimeout(() => {
                setSuccessAlert(null)
            }, 3000);
        }
    }
    useEffect(() => {
        reset({
            questionTitle: question.questionTitle,
            questionAnswer: question.questionAnswer,
        })
    }, [question])
    return (
        <Modal show={isModalQuestionsUpdateOpen} position="top-center">
            <div className='flex flex-col p-6 w-[95%] mx-auto'>
                <div className='font-medium text-center'>
                    EDITAR PREGUNTA
                </div>
                <p class='pb-6 font-light text-sm italic'>Los campos señalados con * son obligatorios.</p>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div class="grid grid-cols-1 gap-6">
                        <div class="relative z-0 mb-6 w-full group">
                            <input type="text" {...register("questionTitle")} class={style.formInput} placeholder=" " />
                            <label class={style.formLabel}>Pregunta*</label>
                            <ErrorWrapper error={errors.questionTitle?.message} />
                        </div>
                        <div class="relative z-0 mb-6 w-full group">
                            <textarea rows="5" {...register("questionAnswer")} class={style.formInput} placeholder=" " />
                            <label class={style.formLabel}>Respuesta*</label>
                            <ErrorWrapper error={errors.questionAnswer?.message} />
                        </div>
                    </div>
                    <div className='text-center flex mb-6'>
                        {error.error && <ErrorWrapper error={error.message} />}
                    </div>
                    <div className='flex flex-col w-[50%] mx-auto'>
                        {loading ? <Loading isLoading={true} /> : <button type="submit" class=" mx-auto bg-gray-300 border shadow hover:text-white hover:bg-green-400 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm px-5 py-2.5 mb-6 text-center duration-300 w-full">Editar Pregunta</button>}

                        <button type="button" class="mx-auto bg-gray-200 border shadow hover:text-white hover:bg-teal-400 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center duration-300 w-full" onClick={() => setIsModalQuestionsUpdateOpen(false)}>Cancelar</button>
                    </div>
                </form>
            </div>
        </Modal >
    );
}

export default ModalQuestionsUpdate;